"use client";

import { RichtextRenderer } from "@/components/atoms/rich-text-render";import { JapanAttraction } from "@/types/generated";
import { useLocale } from "next-intl";
import Image from "next/image";

export interface JapanAttractionWithAreaName extends JapanAttraction {
  areaName: string | null;
  areaTitle: string | null;
}

export interface RestAttractionCardProps {
  attraction: JapanAttractionWithAreaName;
  rank: number;
}

/**
 * RestAttractionCard Component
 * Displays a compact card for an attraction with image, rank badge, and area details.
 * Navigates to the attraction details page when clicked.
 */
export const RestAttractionCard = ({
  attraction,
  rank,
}: RestAttractionCardProps) => {
  const locale = useLocale();

  // Redirects user to the specific attraction detail page when clicked
  return (
    <button
      type="button"
      onClick={() => {
        globalThis.location.href = `/${locale}/${attraction?.slug}`;
      }}
      className="flex h-[100px] w-full cursor-pointer items-center gap-4 overflow-hidden rounded-lg border border-[var(--stroke-gray-light)] bg-white text-left shadow-lg"
    >
      <div className="relative h-full w-[133px] flex-shrink-0">
        <Image
          src={attraction.properties?.overview_image[0]?.cloudflare_url || ""}
          alt={attraction.properties?.overview_image[0]?.alternativeText || ""}
          aria-label={attraction.properties?.overview_image[0]?.caption || ""}
          fill
          className="rounded-md object-cover"
        />
        <div className="absolute top-0 left-0 flex h-10 w-10 items-center justify-center rounded-br-xl bg-[var(--color-secondary-400)] px-3 py-1 text-sm font-bold text-blue-900">
          {rank}
        </div>
      </div>
      <div className="flex-grow">
        <div className="line-clamp-2 text-2xl leading-9">
          {/* Attraction title rendered via RichtextRenderer to handle HTML content */}

          <RichtextRenderer
            customStyle={{
              "": {
                fontWeight: 600,
                color: "var(--text-base-primary)",
              },
            }}
            content={attraction?.properties?.name || ""}
          />
        </div>
        <div className="text-base leading-6 font-normal text-[var(--text-gray-normal)]">
          {attraction.areaTitle}
        </div>
      </div>
    </button>
  );
};
